import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  AFFILIATE_SETTINGS_KEY,
  AffiliateSettingsParams,
  updateAffiliateSettings,
} from '@utils/backend-api/settings';
import { SuccessResponse } from '@utils/interfaces';

export default function useAffiliateSettingsUpdate() {
  const queryClient = useQueryClient();
  const { mutate, data, isLoading, isError } = useMutation(
    (params: AffiliateSettingsParams) => updateAffiliateSettings(params),
    {
      onSuccess: (data: SuccessResponse) => {
        queryClient.invalidateQueries(AFFILIATE_SETTINGS_KEY);
        toast.success(data.message);
      },
      onError: () => {
        toast.error(
          "We couldn't update all of your affiliate settings. Please try again or contact support@theinformation.com."
        );
      },
    }
  );
  return { mutate, data, isLoading, isError };
}
